<template>
  <!-- Modal -->
  <div class="modal fade" id="ArchiveInventoryUpdateModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title">{{ translations('inventory.adjust_inventory_result') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{translations('inventory.jan_code')}}</th>
                <th width='120px' >{{translations('inventory.actual_quantity')}}</th>
                <th>{{translations('inventory.zhang_boshu_number')}}</th>
                <th>{{translations('inventory.discrepancy_number')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{tempDetail.jan_code}}</td>
                <td>
                  <input :placeholder="placeholder" v-model="hisQuantity"  class="form-control form-control-sm" type="number" min="0">
                </td>
                <td>{{tempDetail.amount}}</td>
                <td>
                  <span :class="(hisQuantity - tempDetail.amount) ? 'text-danger' : 'text-dark'">
                    {{hisQuantity - tempDetail.amount}}
                  </span>
                </td>
                <!-- <td><input :placeholder="placeholder" v-model="tempDetail.his_quantity"  class="form-control form-control-sm" type="number"></td> -->
              </tr>
            </tbody>
          </table>

          <div>
            <div class="form-field">
              <label class="form-field__label">{{translations('inventory.update_date')}}:</label>
              <DatePicker
                v-model="inventory_update_date"
                value-type="format"
                format="MM/DD/YYYY"
                placeholder="mm/dd/yyyy"
                class="update-date-field"
                @change="getNewQuantity"
              />
              <input
                v-model="inventoryUpdateTime"
                type="time"
                class="form-control input-time"
                @click="tempUpdateTime = inventoryUpdateTime"
                @blur="getNewQuantity"
              >
            </div>
            <div class="d-flex">
              <p class="mb-1 mt-2 form-field__label">{{ translations('inventory.correction_reason') }}:</p>
              <div class="update-note">
                <textarea class="update_note__text" name="" id="" cols="30" rows="5" v-model="note"></textarea>
              </div>
            </div>
            <div>
              <p class="mb-1 text-primary mt-3 pointer-clickable" @click="triggerShowHistoryUpdate">
                <span>{{ translations('inventory.history') }}&nbsp;</span>
                <span><i :class="showHistoryUpdate ? 'fas fa-angle-double-down' : 'fas fa-angle-double-up'"></i></span>
              </p>
              <ul :class="!showHistoryUpdate ? 'd-none' : 'pl-5'" >
                <li class="mb-2" v-for="history in lastHistoryUpdate" :key="history.history_id">
                  <p class="mb-0">
                    <span>{{ history.inventory_checked_at }}</span>
                    <span class="pl-2">{{ history.personnel }}</span>
                  </p>
                  <p class="mb-0">{{ history.note }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeUpdateInventory" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('inventory.cancel') }}</button>
          <button type="button" class="btn btn-primary" @click="updateInventory()">{{ translations('common.keep') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'

import DatePicker from '@/components/common/DatePicker'
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'ArchiveInventoryUpdateModal',
  components: {
    VueElementLoading,
    DatePicker
  },
  props: {
    detail: {},
    originalDetail: {},
    inventory_at: null,
    selectedCondition: null
  },
  data () {
    return {
      tempDetail: {},
      inventory_update_date: format(new Date(), 'MM/dd/yyyy'),
      inventoryUpdateTime: format(new Date(), 'HH:mm'),
      tempUpdateTime: null,
      isSearching: false,
      placeholder: 0,
      note: '',
      hisQuantity: 0,
      lastHistoryUpdate: [],
      showHistoryUpdate: true
    }
  },
  watch: {
    originalDetail: {
      handler: function (data, oldData) {
        let inventoryCheckedAt = this.detail.inventory_checked_at === null ? new Date() : this.detail.inventory_checked_at
        this.tempDetail = { ...data }
        this.hisQuantity = data.his_quantity
        this.note = ''
        this.getLastHistoryUpdate(data.id)
        this.showHistoryUpdate = true
        this.inventoryUpdateTime = format(new Date(`${inventoryCheckedAt}`), 'HH:mm')
        this.inventory_update_date = format(new Date(`${inventoryCheckedAt}`), 'MM/dd/yyyy')
      },
      deep: true
    },
    detail: {
      handler: function (data, oldData) {
        this.placeholder = data.amount
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },

    clearTempDetail: function () {
      this.tempDetail = {}
    },

    async updateInventory () {
      if (this.tempDetail.his_quantity < 0) {
        this.$toastr.warning('数量を半角数字でご入力ください')
        return
      }

      this.isSearching = true
      try {
        let params = {
          warehouse_id: this.tempDetail.warehouse_id,
          quantity: this.hisQuantity,
          user_id: Number(this.$store.getters['User/id']),
          product_id: this.tempDetail.product_id,
          date: format(new Date(`${this.inventory_update_date} ${this.inventoryUpdateTime}`), "yyyy-MM-dd'T'HH:mm:59"),
          condition: this.selectedCondition,
          note: this.note
        }
        const updateOrder = await this.$http.post(this.$api_url.inventory_update_single, params)
        let $data = this.$invoiceTools.prepareResult(updateOrder.data, '', 'ArchiveInventories:updateInventory')
        if ($data.success === true) {
          const paramsHistoryId = {
            warehouses_id: this.tempDetail.warehouse_id,
            inventory_at: this.inventory_update_date,
            condition: this.selectedCondition,
            jan_code: this.tempDetail.jan_code
          }
          const responseHistoryId = await this.$http.post(this.$api_url.inventory_list, paramsHistoryId)
          if (responseHistoryId.data.status && responseHistoryId.data.list) {
            this.$toastr.success('数量の変更に成功しました。', 'Success')
            let getOldTime = format(new Date(`${this.tempDetail.inventory_checked_at === null ? new Date() : this.tempDetail.inventory_checked_at}`), 'HH:mm')
            let inventoryUpdateDate = format(new Date(`${this.inventory_update_date} ${this.inventoryUpdateTime}`), "yyyy-MM-dd'T'HH:mm:ss")
            let oldInventoryChecked = format(new Date(`${this.inventory_at} ${getOldTime}`), "yyyy-MM-dd'T'HH:mm:ss")
            if ((inventoryUpdateDate >= oldInventoryChecked) &&
            this.inventory_at === format(new Date(`${this.inventory_update_date}`), 'yyyy-MM-dd')) {
              this.updateTable(responseHistoryId.data.list[0])
            } else {
              this.handleCloseModal()
              const btn = this.$refs.closeUpdateInventory
              btn.click()
            }
          }
          this.inventory_update_date = format(new Date(), 'MM/dd/yyyy')
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
        this.isSearching = false
      } catch (error) {
        console.log(error)
        this.isSearching = false
        console.log('ArchiveInventories:updateInventory:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    async getNewQuantity () {
      if (this.tempUpdateTime === this.inventoryUpdateTime) {
        return
      }
      this.isSearching = true
      try {
        const params = {
          condition: this.selectedCondition,
          date: format(new Date(`${this.inventory_update_date} ${this.inventoryUpdateTime}`), "yyyy-MM-dd'T'HH:mm:59"),
          product_id: this.tempDetail.product_id,
          warehouse_id: this.tempDetail.warehouse_id
        }
        const { data: { status, data } } = await this.$http.post(
          this.$api_url.inventory_quantity_single,
          params
        )

        if (status) {
          this.tempDetail.amount = data
        } else {
          throw new Error('Something went wrong.')
        }
      } catch (error) {} finally {
        this.isSearching = false
        this.tempUpdateTime = null
      }
    },

    updateTable (data) {
      if (!data) return
      this.handleCloseModal()
      const btn = this.$refs.closeUpdateInventory
      btn.click()
      this.detail.his_quantity = this.hisQuantity
      this.detail.inventory_checked_at = data.inventory_checked_at
      this.detail.personnel = data.personnel
      this.detail.history_id = data.history_id
      this.detail.diff_count = data.diff_count
      this.detail.diff_price_jpy_total = data.diff_price_jpy_total
      this.detail.note = this.note
      this.detail.modified_at = data.modified_at
    },

    async getLastHistoryUpdate (stockId) {
      try {
        let params = {
          stock_id: stockId,
          inventory_at: this.inventory_at,
          condition: this.selectedCondition
        }
        const responseLastHistory = await this.$http.post(this.$api_url.inventory_last_history, params)
        let $data = this.$invoiceTools.prepareResult(responseLastHistory.data, '', 'ArchiveInventories:updateInventory')
        if ($data.success === true) {
          this.lastHistoryUpdate = responseLastHistory.data.list
        } else {
          // this.$toastr.error($data.data, 'エラー')
          this.lastHistoryUpdate = []
        }
      } catch (error) {
        console.log('ArchiveInventories:updateInventory:catch(error): ', JSON.stringify(error))
      }
    },

    triggerShowHistoryUpdate () {
      this.showHistoryUpdate = !this.showHistoryUpdate
    },

    handleCloseModal () {
      this.$emit('modal-closed')
    }
  }
}
</script>

<style scoped>
.update-date-field {
  width: 150px;
}

.form-field {
  display: flex;
  align-items: center;
  margin-right: 30px;
  margin-bottom: 10px;
}

.form-field__label {
  margin-bottom: 0px;
  margin-right: 10px;
  min-width: 60px
}

.update-note {
  width: 100%;
}

.update_note__text {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
}

.update_note__text:focus {
  outline: none;
}
</style>
